// extracted by css-extract-rspack-plugin
export default {"body":"U1HDY","column":"en2jN","preview":"AmIml","header":"JOG5g"};